import "./default-button.component.scss";
import Button from "@mui/material/Button";
import {
  ButtonProps,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import React, { FC, useState } from "react";
import DesktopDatePicker, {
  DesktopDatePickerProps,
} from "@mui/lab/DesktopDatePicker";

const datePickerIcon: FC<any> = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.06107 20.0451L3.50191 19.4383L3.06107 20.0451ZM1.95491 18.9389L2.56168 18.4981L1.95491 18.9389ZM18.0451 18.9389L17.4383 18.4981L18.0451 18.9389ZM16.9389 20.0451L17.3798 20.6518L16.9389 20.0451ZM16.9389 3.95492L17.3798 3.34815L16.9389 3.95492ZM18.0451 5.06107L17.4383 5.50191L18.0451 5.06107ZM3.06107 3.95492L3.50191 4.56168H3.50191L3.06107 3.95492ZM1.95491 5.06107L2.56168 5.50191L1.95491 5.06107ZM17.2178 15.0616L17.1005 14.3208H17.1005L17.2178 15.0616ZM13.0616 19.2178L12.3208 19.1005V19.1005L13.0616 19.2178ZM7 12.25C6.58579 12.25 6.25 12.5858 6.25 13C6.25 13.4142 6.58579 13.75 7 13.75V12.25ZM13 13.75C13.4142 13.75 13.75 13.4142 13.75 13C13.75 12.5858 13.4142 12.25 13 12.25V13.75ZM12.25 4C12.25 4.41421 12.5858 4.75 13 4.75C13.4142 4.75 13.75 4.41421 13.75 4H12.25ZM13.75 1C13.75 0.585786 13.4142 0.25 13 0.25C12.5858 0.25 12.25 0.585786 12.25 1H13.75ZM6.25 4C6.25 4.41421 6.58579 4.75 7 4.75C7.41421 4.75 7.75 4.41421 7.75 4H6.25ZM7.75 1C7.75 0.585786 7.41421 0.25 7 0.25C6.58579 0.25 6.25 0.585786 6.25 1H7.75ZM18.9711 15L19.7206 15.0257L18.9711 15ZM1.02893 9L0.279368 8.97432L1.02893 9ZM18.9711 9L19.7206 8.97432L18.9711 9ZM10 20.25C8.10843 20.25 6.74999 20.249 5.69804 20.135C4.66013 20.0225 4.00992 19.8074 3.50191 19.4383L2.62023 20.6518C3.42656 21.2377 4.37094 21.5 5.53648 21.6263C6.68798 21.751 8.14184 21.75 10 21.75V20.25ZM0.25 12C0.25 13.8582 0.248971 15.312 0.373728 16.4635C0.500006 17.6291 0.762324 18.5734 1.34815 19.3798L2.56168 18.4981C2.19259 17.9901 1.97745 17.3399 1.865 16.302C1.75103 15.25 1.75 13.8916 1.75 12H0.25ZM3.50191 19.4383C3.14111 19.1762 2.82382 18.8589 2.56168 18.4981L1.34815 19.3798C1.70281 19.8679 2.13209 20.2972 2.62023 20.6518L3.50191 19.4383ZM17.4383 18.4981C17.1762 18.8589 16.8589 19.1762 16.4981 19.4383L17.3798 20.6518C17.8679 20.2972 18.2972 19.8679 18.6518 19.3798L17.4383 18.4981ZM16.4981 4.56168C16.8589 4.82382 17.1762 5.14111 17.4383 5.50191L18.6518 4.62023C18.2972 4.13209 17.8679 3.70281 17.3798 3.34815L16.4981 4.56168ZM2.62023 3.34815C2.13209 3.70281 1.70281 4.13209 1.34815 4.62023L2.56168 5.50191C2.82382 5.14111 3.14111 4.82382 3.50191 4.56168L2.62023 3.34815ZM17.1005 14.3208C14.6401 14.7105 12.7105 16.6401 12.3208 19.1005L13.8023 19.3352C14.0904 17.5166 15.5166 16.0904 17.3352 15.8023L17.1005 14.3208ZM7 13.75H13V12.25H7V13.75ZM18.9711 14.25C18.0888 14.25 17.5579 14.2484 17.1005 14.3208L17.3352 15.8023C17.647 15.7529 18.0338 15.75 18.9711 15.75L18.9711 14.25ZM18.25 12C18.25 13.1731 18.2499 14.1456 18.2215 14.9743L19.7206 15.0257C19.7501 14.1658 19.75 13.1648 19.75 12H18.25ZM18.2215 14.9743C18.158 16.8292 17.9509 17.7925 17.4383 18.4981L18.6518 19.3798C19.4537 18.2761 19.6564 16.8991 19.7206 15.0257L18.2215 14.9743ZM13.75 20.9711C13.75 20.0338 13.7529 19.647 13.8023 19.3352L12.3208 19.1005C12.2484 19.5579 12.25 20.0888 12.25 20.9711L13.75 20.9711ZM10 21.75C11.1648 21.75 12.1658 21.7501 13.0257 21.7206L12.9743 20.2215C12.1456 20.2499 11.1731 20.25 10 20.25V21.75ZM13.0257 21.7206C14.8991 21.6564 16.2761 21.4537 17.3798 20.6518L16.4981 19.4383C15.7925 19.9509 14.8292 20.158 12.9743 20.2215L13.0257 21.7206ZM1.75 12C1.75 10.8269 1.75009 9.85445 1.77849 9.02568L0.279368 8.97432C0.249906 9.83424 0.25 10.8352 0.25 12H1.75ZM1.77849 9.02568C1.84204 7.17075 2.04907 6.20746 2.56168 5.50191L1.34815 4.62023C0.546296 5.7239 0.343555 7.10087 0.279368 8.97432L1.77849 9.02568ZM1.02893 9.75H18.9711V8.25H1.02893V9.75ZM19.75 12C19.75 10.8352 19.7501 9.83424 19.7206 8.97432L18.2215 9.02568C18.2499 9.85445 18.25 10.8269 18.25 12H19.75ZM19.7206 8.97432C19.6564 7.10087 19.4537 5.7239 18.6518 4.62023L17.4383 5.50191C17.9509 6.20746 18.158 7.17075 18.2215 9.02568L19.7206 8.97432ZM13.75 4V3.02893H12.25V4H13.75ZM13.75 3.02893V1H12.25V3.02893H13.75ZM10 3.75C11.1731 3.75 12.1456 3.75009 12.9743 3.77849L13.0257 2.27937C12.1658 2.24991 11.1648 2.25 10 2.25V3.75ZM12.9743 3.77849C14.8292 3.84204 15.7925 4.04907 16.4981 4.56168L17.3798 3.34815C16.2761 2.5463 14.8991 2.34356 13.0257 2.27937L12.9743 3.77849ZM7.75 4V3.02893H6.25V4H7.75ZM7.75 3.02893V1H6.25V3.02893H7.75ZM10 2.25C8.83522 2.25 7.83424 2.24991 6.97432 2.27937L7.02568 3.77849C7.85445 3.75009 8.82692 3.75 10 3.75V2.25ZM6.97432 2.27937C5.10087 2.34356 3.7239 2.5463 2.62023 3.34815L3.50191 4.56168C4.20746 4.04907 5.17075 3.84204 7.02568 3.77849L6.97432 2.27937Z"
        fill="#007DEF"
      />
    </svg>
  );
};

interface DatePickerProps extends DesktopDatePickerProps {
  helperText?: any;
  error?: any;
}

export const DatePickerRenderInput = (params: any) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <TextField {...params} className="date-picker-input" variant="filled" />
  );
};
export const DatePickerComponent = (props: any) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <DatePickerInput
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={{
            shrink: true,
          }}
          className="date-picker-input"
          variant="filled"
          onClick={(e) => setOpen(true)}
          error={props.error}
          autoComplete="off"
        />
      )}
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    />
  );
};

export const DatePickerInput: React.FunctionComponent<DatePickerProps> = (
  props
) => {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <FormControl
          variant={"filled"}
          fullWidth={true}
          size={"medium"}
          error={props.error}
        >
          <DesktopDatePicker
            components={{
              OpenPickerIcon: datePickerIcon,
            }}
            {...props}
          />
          <FormHelperText>{props.helperText}</FormHelperText>
        </FormControl>
      </LocalizationProvider>
    </>
  );
};
